import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ContractsCommonService } from '../../service/contract-creation/contracts-common.service';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-carrier-info',
  templateUrl: './carrier-info.component.html',
  styleUrls: ['./carrier-info.component.scss'],
  providers: [MessageService],
  standalone: false
})
export class CarrierInfoComponent implements OnDestroy {
  @ViewChild('carrierTable') carrierTable!: Table;

  visible: boolean = false;
  carriersDetails: any;
  searchTerm: string = '';
  private subscription: Subscription = new Subscription();

  constructor(private contractCommonService: ContractsCommonService, private messageService: MessageService) {
    const cachedCarriers = this.contractCommonService.getCarrierSync();
    if (cachedCarriers) {
      this.carriersDetails = cachedCarriers;
    } else {
      console.log('Fetching carrier details...');
      this.subscription.add(
        this.contractCommonService.carrier$.subscribe((response: any) => {
          if (response) {
            this.carriersDetails = response;
          }
        })
      );

      this.subscription.add(
        this.contractCommonService.getAllCarriers().subscribe({
          next: (response: any) => {
            if (response && response.data) {
              this.carriersDetails = response.data;
            }
          },
          error: (error) => {
            console.error('Error fetching carriers:', error);
          }
        })
      );
    }
  }

  copyToClipboard(value: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Copied to clipboard: ' + value
      });
    }).catch(err => {
      console.error('Error copying text: ', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to copy text.'
      });
    });
  }

  downloadTableData(): void {
    const csvData = this.convertToCSV(this.carriersDetails);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'carrier_details.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private convertToCSV(data: any[]): string {
    if (!data || !data.length) {
      return '';
    }

    const headers = ['Carrier Name', 'Carrier SCAC'];
    const rows = data.map(row => [
      this.escapeCSVValue(row.carrierName),
      this.escapeCSVValue(row.carrierScac)
    ]);

    const csvRows = rows.map(row => row.join(','));
    return [headers.join(','), ...csvRows].join('\n');
  }

  private escapeCSVValue(value: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  }

  resetFilters(): void {
    this.searchTerm = '';
    if (this.carrierTable) {
      this.carrierTable.clear();
      this.carrierTable.filterGlobal(this.searchTerm, 'contains');
      this.carrierTable.reset();
      this.carrierTable.rows = 10;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}